// extracted by mini-css-extract-plugin
export default {"header":"styles_header__fOWi6","backButton":"styles_backButton__4XVxQ","title":"styles_title__GVOTh","form":"styles_form__eFQwU","submitButton":"styles_submitButton__GPn0H"};